export default __webpack_public_path__ + "static/media/coop-puglia.4d8eee9a.png";